/* LumaPine theme scripts: LED tree preview, countdown, bundles, AJAX cart. */
(function () {
  /* ---------- LED tree renderer ---------- */
  const hsl = (h, s, l) => `hsl(${h},${s}%,${l}%)`;
  const rnd = (i) => { const x = Math.sin(i * 127.1) * 43758.5453; return x - Math.floor(x); };

  // Each pattern maps a pixel (u: -1..1 across, v: 0 top..1 bottom, t: seconds, i: index) to a color.
  const PATTERNS = {
    'Snowfall': (u, v, t) => {
      const col = Math.round((u + 1) * 12), speed = .15 + rnd(col) * .15;
      const d = Math.abs(v - ((t * speed + rnd(col * 7)) % 1.2 - .1));
      return d < .04 ? '#ffffff' : (d < .09 ? '#9fd3ff' : hsl(210, 60, 14));
    },
    'Rainbow': (u, v, t) => hsl(((v * 360 - t * 120 + u * 40) % 360 + 360) % 360, 90, 55),
    'Star Burst': (u, v, t) => {
      const dx = u * 1.1, dy = v - .42, r = Math.hypot(dx, dy), a = Math.atan2(dy, dx);
      if (r < .18 + .1 * Math.cos(5 * a - t)) return '#ffd84a';
      return Math.abs((r - t * .25) % .25) < .03 ? '#fff6c4' : hsl(140, 50, 14);
    },
    'Candy Cane': (u, v, t) => (Math.floor((v * 6 + u * 1.5 + t * .6) * 2) % 2 === 0) ? '#ff2b4a' : '#ffffff',
    'Aurora': (u, v, t) => {
      const w = Math.sin(u * 3 + t * .8) * .12 + Math.sin(u * 7 - t * 1.3) * .05 + .45;
      const d = Math.abs(v - w);
      return d < .22 ? hsl(150 + u * 60 + Math.sin(t) * 40, 90, 60 - d * 180) : hsl(230, 60, 10);
    },
    'Heart': (u, v, t) => {
      const s = 1 + .08 * Math.sin(t * 4), x = u * 1.4 / s, y = -(v - .5) * 1.6 / s;
      return Math.pow(x * x + y * y - 1, 3) - x * x * y * y * y < 0 ? '#ff2d55' : hsl(340, 40, 14);
    },
    'Fireworks': (u, v, t) => {
      let c = null;
      for (let k = 0; k < 3; k++) {
        const cyc = Math.floor(t * .5 + k / 3), ph = (t * .5 + k / 3) % 1;
        const cx = (rnd(cyc * 3 + k) - .5) * 1.2, cy = .2 + rnd(cyc * 5 + k) * .5;
        if (Math.abs(Math.hypot((u - cx) * 1.1, v - cy) - ph * .45) < .035) c = hsl(rnd(cyc * 9 + k) * 360, 95, 65 - ph * 25);
      }
      return c || hsl(240, 40, 8);
    },
    'Warm Glow': (u, v, t, i) => hsl(38, 95, 40 + 25 * Math.sin(t * 2 + rnd(i) * 12)),
    'Gift Box': (u, v, t) => {
      if (Math.abs(u) < .1 || Math.abs(v - .6) < .05) return '#ffd84a';
      if (v > .35 && v < .9 && Math.abs(u) < .75) return '#e3263f';
      if (v > .22 && v < .35 && Math.abs(Math.abs(u) - .2) < .15 - (v - .22) * .5) return '#ffd84a';
      return hsl(140, 50, 12 + 4 * Math.sin(t * 3 + u * 10));
    }
  };

  function drawStar(c, x, y, R) {
    c.beginPath();
    for (let k = 0; k < 10; k++) {
      const a = -Math.PI / 2 + k * Math.PI / 5, r = k % 2 ? R * .45 : R;
      c.lineTo(x + Math.cos(a) * r, y + Math.sin(a) * r);
    }
    c.closePath(); c.fill();
  }

  function initTree(canvas) {
    if (canvas._lp) return canvas._lp;
    const ctx = canvas.getContext('2d');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let pts = [], W = 0, H = 0, visible = true;
    const state = { design: canvas.dataset.design || 'Snowfall' };

    function layout() {
      const dpr = window.devicePixelRatio || 1;
      W = canvas.clientWidth; H = canvas.clientHeight;
      canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      pts = [];
      const top = H * .1, bottom = H * .9, strands = 25, per = 36;
      for (let s = 0; s < strands; s++) {
        const u = s / (strands - 1) * 2 - 1;
        for (let k = 0; k < per; k++) {
          const v = k / (per - 1);
          if (Math.abs(u) > v * 1.02 + .02) continue; // keep the triangle shape
          pts.push({ u, v, x: W / 2 + u * W * .42, y: top + v * (bottom - top), i: pts.length });
        }
      }
    }

    function frame(ms) {
      if (visible) {
        const t = reduced ? 2 : ms / 1000, pattern = PATTERNS[state.design] || PATTERNS.Snowfall;
        const r = Math.max(2, W / 150);
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = '#3a2416'; ctx.fillRect(W / 2 - W * .03, H * .9, W * .06, H * .06);
        ctx.globalCompositeOperation = 'lighter';
        for (const p of pts) {
          const c = pattern(p.u, p.v, t, p.i);
          ctx.fillStyle = c; ctx.shadowColor = c; ctx.shadowBlur = r * 3;
          ctx.beginPath(); ctx.arc(p.x, p.y, r, 0, 7); ctx.fill();
        }
        ctx.shadowBlur = 18; ctx.shadowColor = '#ffd84a'; ctx.fillStyle = '#ffe27a';
        drawStar(ctx, W / 2, H * .07, W * .035 * (1 + .08 * Math.sin(t * 3)));
        ctx.shadowBlur = 0; ctx.globalCompositeOperation = 'source-over';
      }
      if (!reduced) requestAnimationFrame(frame);
    }

    new ResizeObserver(() => { layout(); if (reduced) frame(0); }).observe(canvas);
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; }).observe(canvas);
    layout(); requestAnimationFrame(frame);

    canvas._lp = {
      set(d) {
        state.design = d;
        if (reduced) frame(0);
        const tag = canvas.parentElement.querySelector('[data-led-tag]');
        if (tag) tag.textContent = 'Design: ' + d;
      }
    };
    return canvas._lp;
  }

  function initTrees(root) {
    root.querySelectorAll('[data-led-tree]').forEach(initTree);
    root.querySelectorAll('[data-led-switch]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const scope = btn.closest('.shopify-section') || document;
        const canvas = scope.querySelector('[data-led-tree]');
        if (canvas) initTree(canvas).set(btn.dataset.ledSwitch);
        btn.parentElement.querySelectorAll('[data-led-switch]').forEach((b) => b.classList.toggle('on', b === btn));
      });
    });
    root.querySelectorAll('[data-img-switch]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const img = (btn.closest('.gallery') || document).querySelector('[data-main-img]');
        if (img) { img.src = btn.dataset.imgSwitch; img.removeAttribute('srcset'); }
        btn.parentElement.querySelectorAll('[data-img-switch]').forEach((b) => b.classList.toggle('on', b === btn));
      });
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns(root) {
    root.querySelectorAll('[data-countdown]').forEach((el) => {
      if (el._lp) return;
      const parts = el.dataset.countdown.split('-').map(Number);
      const target = new Date(parts[0], (parts[1] || 1) - 1, parts[2] || 1, 23, 59, 59);
      if (isNaN(target)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const set = (sel, n) => { el.querySelector(sel).firstChild.nodeValue = pad(n); };
      const tick = () => {
        let s = Math.max(0, Math.floor((target - new Date()) / 1000));
        set('[data-d]', Math.floor(s / 86400)); s %= 86400;
        set('[data-h]', Math.floor(s / 3600)); s %= 3600;
        set('[data-m]', Math.floor(s / 60)); set('[data-s]', s % 60);
      };
      tick(); el._lp = setInterval(tick, 1000);
    });
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    const fmt = (n, dec, thou, sep) => {
      const [i, d] = (n / 100).toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : '');
    };
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: fmt(cents, 2, ',', '.'),
      amount_no_decimals: fmt(cents, 0, ',', '.'),
      amount_with_comma_separator: fmt(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_apostrophe_separator: fmt(cents, 2, "'", '.'),
      amount_with_space_separator: fmt(cents, 2, ' ', ',')
    }[key] || fmt(cents, 2, ',', '.')));
  }

  /* ---------- Toast & cart count ---------- */
  function toast(msg) {
    const t = document.getElementById('lp-toast');
    if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 2400);
  }
  async function refreshCartCount() {
    const res = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
  }

  /* ---------- Product: bundles + AJAX add ---------- */
  function initProduct(root) {
    root.querySelectorAll('[data-lp-product]').forEach((wrap) => {
      if (wrap._lp) return; wrap._lp = true;
      const section = wrap.closest('.shopify-section') || document;
      const fmtEl = section.querySelector('[data-money-format]');
      const format = fmtEl ? JSON.parse(fmtEl.textContent) : null;
      const form = wrap.querySelector('[data-lp-form]');
      const qtyInput = wrap.querySelector('[data-qty]');
      const select = wrap.querySelector('[data-variant-select]');
      const btn = wrap.querySelector('[data-add-btn]');
      const sticky = section.querySelector('[data-sticky]');
      let base = { price: +wrap.dataset.basePrice, compare: +wrap.dataset.baseCompare };

      function render() {
        const checked = wrap.querySelector('input[name="lp-bundle"]:checked');
        let now = base.price, was = base.compare, qty = 1;
        wrap.querySelectorAll('input[name="lp-bundle"]').forEach((inp) => {
          const q = +inp.value, disc = +inp.dataset.discount || 0;
          const label = inp.closest('.bundle');
          // Match Shopify's automatic discount: percentage taken per unit, rounded down to the cent
          const bNow = (base.price - Math.floor(base.price * disc / 100)) * q, bWas = base.compare * q;
          label.querySelector('[data-bundle-now]').textContent = formatMoney(bNow, format);
          label.querySelector('[data-bundle-was]').textContent = bWas > bNow ? formatMoney(bWas, format) : '';
          if (inp === checked) { now = bNow; was = bWas; qty = q; }
        });
        qtyInput.value = qty;
        const set = (sel, txt) => { const el = wrap.querySelector(sel); if (el) el.textContent = txt; };
        set('[data-price-now]', formatMoney(now, format));
        set('[data-price-was]', was > now ? formatMoney(was, format) : '');
        set('[data-price-save]', was > now ? 'SAVE ' + Math.round((1 - now / was) * 100) + '%' : '');
        const sp = section.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = formatMoney(now, format);
      }

      wrap.addEventListener('change', (e) => {
        if (e.target === select) {
          const opt = select.selectedOptions[0];
          base = { price: +opt.dataset.price, compare: +opt.dataset.compare };
        }
        render();
      });
      render();

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        btn.disabled = true;
        try {
          const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          await refreshCartCount();
          toast('🎄 Added ' + qtyInput.value + ' to cart!');
        } catch (err) {
          toast(err.message);
        } finally {
          btn.disabled = false;
        }
      });

      if (sticky && btn) {
        new IntersectionObserver(([e]) => {
          sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btn);
      }
    });
  }

  /* ---------- Falling snow ---------- */
  function initSnow(canvas) {
    if (canvas._lp) return; canvas._lp = true;
    const ctx = canvas.getContext('2d');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const density = +canvas.dataset.density || 150;
    let W = 0, H = 0, flakes = [], visible = true, last = 0;

    function resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = canvas.clientWidth; H = canvas.clientHeight;
      canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      // Scale flake count with area so phones aren't overloaded
      const count = Math.round(density * Math.min(1, (W * H) / (1440 * 600)) + 20);
      flakes = Array.from({ length: count }, () => ({
        x: Math.random() * W, y: Math.random() * H,
        r: .8 + Math.random() * 2.8, s: .3 + Math.random() * .9,
        d: Math.random() * Math.PI * 2, a: .5 + Math.random() * .5
      }));
    }

    function draw(ms) {
      const dt = Math.min(50, ms - last || 16) / 16; last = ms;
      if (visible) {
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = '#fff';
        for (const f of flakes) {
          if (!reduced) {
            f.y += f.s * f.r * .5 * dt;
            f.d += .01 * dt;
            f.x += Math.sin(f.d) * .4 * dt;
            if (f.y > H + 5) { f.y = -5; f.x = Math.random() * W; }
            if (f.x > W + 5) f.x = -5; else if (f.x < -5) f.x = W + 5;
          }
          ctx.globalAlpha = f.a;
          ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 7); ctx.fill();
        }
        ctx.globalAlpha = 1;
      }
      if (!reduced) requestAnimationFrame(draw);
    }

    new ResizeObserver(() => { resize(); if (reduced) draw(0); }).observe(canvas);
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; }).observe(canvas);
    resize(); requestAnimationFrame(draw);
  }

  /* ---------- Quick add from product cards ---------- */
  function initQuickAdd(root) {
    root.querySelectorAll('form[data-quick-add]').forEach((form) => {
      if (form._lp) return; form._lp = true;
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('button');
        btn.disabled = true;
        try {
          const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          await refreshCartCount();
          toast('🎄 Added to cart!');
        } catch (err) {
          toast(err.message);
        } finally {
          btn.disabled = false;
        }
      });
    });
  }

  /* ---------- Footer tracking lookup ---------- */
  function initTrackForms(root) {
    root.querySelectorAll('form[data-track-form]').forEach((form) => {
      if (form._lp) return; form._lp = true;
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        // Allow several numbers separated by spaces or commas; trackers accept them comma-joined
        const nums = form.elements.tracking.value.split(/[\s,;]+/).filter(Boolean).join(',');
        if (!nums) return;
        window.open((form.dataset.lookup || 'https://t.17track.net/en#nums=') + encodeURIComponent(nums), '_blank', 'noopener');
      });
    });
  }

  /* ---------- Cart page: auto-updating quantities ---------- */
  function initCart(root) {
    root.querySelectorAll('[data-cart-root]').forEach((cartRoot) => {
      if (cartRoot._lp) return; cartRoot._lp = true;
      const base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      let timer = null, busy = false;

      async function change(line, quantity) {
        busy = true;
        cartRoot.classList.add('is-updating');
        try {
          const res = await fetch(base + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, quantity })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not update cart');
          // Re-render this section so prices, discounts and totals come straight from Shopify
          const html = await fetch(base + 'cart?section_id=' + cartRoot.dataset.sectionId).then((r) => r.text());
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-root]');
          if (fresh) cartRoot.innerHTML = fresh.innerHTML;
          document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = data.item_count; });
        } catch (err) {
          toast(err.message);
        } finally {
          busy = false;
          cartRoot.classList.remove('is-updating');
        }
      }

      const lineOf = (el) => +el.closest('[data-line]').dataset.line;
      cartRoot.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-qty-step], [data-qty-set]');
        if (!btn || busy) return;
        e.preventDefault();
        const input = btn.closest('[data-line]').querySelector('input[name="updates[]"]');
        const next = btn.dataset.qtySet !== undefined ? +btn.dataset.qtySet : Math.max(0, (+input.value || 0) + +btn.dataset.qtyStep);
        input.value = next;
        // Short delay so quick repeated clicks are sent as one update
        clearTimeout(timer);
        timer = setTimeout(() => change(lineOf(btn), +input.value), 250);
      });
      cartRoot.addEventListener('change', (e) => {
        if (e.target.name !== 'updates[]' || busy) return;
        clearTimeout(timer);
        change(lineOf(e.target), Math.max(0, parseInt(e.target.value, 10) || 0));
      });
      // Enter in a quantity box updates the cart instead of submitting the form
      cartRoot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.name === 'updates[]') { e.preventDefault(); e.target.blur(); }
      });
    });
  }

  function init(root) {
    initTrees(root); initCountdowns(root); initProduct(root);
    root.querySelectorAll('[data-snow]').forEach(initSnow);
    initQuickAdd(root);
    initTrackForms(root);
    initCart(root);
  }
  init(document);
  // Re-run when a section is added or edited in the theme editor
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
